import {ErrorMessage} from 'formik';
import React, {useCallback, useEffect, useMemo, useState} from "react";
import BasicButton from '../BasicButton';
import BasicInput from '../BasicInput';
import BasicSelect from '../BasicSelect';
import './styles.css';
import TrashIcon from '../icons/TrashIcon';

const SHORTCODES = [
  {
    label: 'Candidate ID',
    value: '{{candidateId}}',
    defaultName: 'candidateId',
  },
  {
    label: 'Process ID',
    value: '{{processId}}',
    defaultName: 'processId',
  },
  {
    label: 'Candidate name',
    value: '{{processName}}',
    defaultName: 'processName',
  },
  {
    label: 'Candidate email',
    value: '{{candidateEmail}}',
    defaultName: 'candidateEmail',
  },
  {
    label: 'Application Process ID',
    value: '{{applicationProcessId}}',
    defaultName: 'applicationProcessId',
  },
  {
    label: 'Apply date',
    value: '{{applyDate}}',
    defaultName: 'applyDate',
  },
  {
    label: 'Firm Name',
    value: '{{firmName}}',
    defaultName: 'firmName',
  },
]

const LinkBuilder = ({
  name,
  placeholder,
  value,
  isValid,
  onBlur,
  onChange,
  setFieldValue
}) => {
  const [parameters, setParameters] = useState([]);
  const url = useMemo(() => {
    if (value && isValid) {
      try {
        return new URL(value);
      } catch (e) {
        return null;
      }
    }

    return null;
  }, [value, isValid]);

  useEffect(() => {
    if (!value) {
      setParameters([]);
    }

    try {
      const newUrl = new URL(value);
      const urlParams = Array.from(newUrl.searchParams.entries());

      setParameters(urlParams);
    } catch (e) {}
  }, [value]);

  const onParamsChange = useCallback((newParams) => {
    setParameters(newParams);
    const newUrl = new URL(value);
    newUrl.search = new URLSearchParams(newParams).toString();

    setFieldValue(name, decodeURI(newUrl.toString()));
  }, [value]);

  return (
    <div>
      <BasicInput
        name={name}
        inputType="text"
        content={value}
        placeholder={placeholder}
        controlFunc={onChange}
        isValid={isValid}
        touchFunc={onBlur}
      />
      <ErrorMessage
        name={name}
        render={message => (
          <div className="form__error">{message}</div>
        )}
      />
      <div className={'link-builder'}>
        <div className={'link-builder__param-label'}>URL Parameters</div>
        {url && (
          <div className={'link-builder__params'}>
            {parameters.map((parameter, index) => {
              return (
                <div key={index} className={'link-builder__param'}>
                  <BasicInput
                    inputType="text"
                    content={parameter[0] || ''}
                    placeholder={'Name'}
                    isValid={true}
                    controlFunc={(e) => {
                      const newParams = [...parameters];
                      newParams[index][0] = e.target.value;
                      onParamsChange(newParams);
                    }}
                  />
                  <BasicSelect
                    options={SHORTCODES}
                    value={SHORTCODES.find(s => s.value === parameter[1]) || undefined}
                    placeholder={parameter[1] || 'Select shortcode'}
                    controlFunc={e => {
                      const newParams = [...parameters];
                      newParams[index][1] = e.value;
                      onParamsChange(newParams);
                    }}
                    isValid={true}
                  />
                  <button className={'link-builder__param-remove'} onClick={() => {
                    const newParams = [...parameters];
                    newParams.splice(index, 1);
                    onParamsChange(newParams);
                  }}>
                    <TrashIcon size={16} />
                  </button>
                </div>
              );
            })}
          </div>
        )}
        <BasicButton disabled={!url} btnText={'Add parameter'} btnArrow={false} controlFunc={() => {
          const newParams = [...parameters, [SHORTCODES[0].defaultName, '']];
          onParamsChange(newParams)
        }} />
      </div>
    </div>
  );
};

export default LinkBuilder;
